import { ProfileStatusEnum, TurnTargetsEnum } from '@/types/turn-enums';
import { TurnTargets } from '@/types/turn-api';
import { ActionFlags } from './types';

/**
 * Statuses where Resume checks must not run. `run_pending_checks` is not gated server-side, so the
 * button would still kick SSN / criminal / MVR even when the FSM cannot leave the current state.
 * `intl_emailed` is the international sibling of `emailed` (not on ProfileStatusEnum yet).
 */
export const RESUME_CHECKS_DISABLED_TOOLTIPS: Record<string, string> = {
  [ProfileStatusEnum.Initiated]:
    'Disabled in Initiated. The candidate has not started the screening yet, so there are no checks to resume.',
  [ProfileStatusEnum.Emailed]: 'Disabled in Emailed. The invite is out and the candidate has not consented.',
  intl_emailed: 'Disabled in Emailed. The invite is out and the candidate has not consented.',
  [ProfileStatusEnum.Approved]:
    'Disabled in Approved. The screening is already complete. Resuming would re-run vendor searches without changing this status.',
  [ProfileStatusEnum.Rejected]:
    'Disabled in Rejected. The screening already ended in a rejection. Resuming would re-run vendor searches without changing this status.',
};

export const RESUME_CHECKS_DISABLED_STATUSES: string[] = Object.keys(RESUME_CHECKS_DISABLED_TOOLTIPS);

export const getResumeChecksDisabledTooltip = (status: string): string | undefined =>
  RESUME_CHECKS_DISABLED_TOOLTIPS[status];

export const defaults: Record<ActionFlags, boolean> = {
  edit: true,
  list: false,
  delete: true,
  refresh: true,
  viewDashboard: true,
  viewReport: true,
  setPending: false,
  editStatus: false,
  resumeChecks: false,
  sendPreAdverse: false,
  sendAdverse: false,
  editNote: false,
  editDispute: false,
  disableConsentLink: true,
  moveWorkerForward: true,
  rerunAddresses: true,
};

export const ON_ACTION_TARGETS: TurnTargets[] = [
  TurnTargetsEnum.EditDispute,
  TurnTargetsEnum.EditNote,
  TurnTargetsEnum.EditStatus,
];
